export default __webpack_public_path__ + "static/media/32032_ProCellCultureSystem_ModuleOverview_PRINT_2500.eb6baad8.jpg";